import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const FileQuestionModel = types.model("FileQuestionModel", {
  title: types.string,
  answers: types.array(types.string),
});

export interface FileQuestionModelInstance extends Instance<typeof FileQuestionModel> {}
export type FileQuestionModelSnapshot = SnapshotIn<typeof FileQuestionModel>;
